import YAML from "../util/YAML";
import ChartBase, { ChartType } from "./ChartBase";
import BPMEvent from "./events/BPMEvent";
import HoldEndEvent from "./events/HoldEndEvent";
import HoldEvent from "./events/HoldEvent";
import NoteEvent from "./events/NoteEvent";
import SVEvent from "./events/SVEvent";
export default class ChartQuaver extends ChartBase {
    parse(data) {
        // Decode YAML
        let collections = YAML.decode(data);
        // Build data
        var audioExt = collections["AudioFile"].substr(-3).toLowerCase();
        if (audioExt != "mp3") {
            console.error("QUA: Invalid: [", audioExt, "]");
            return false;
        }
        this.info = {
            title: collections["Title"],
            artist: collections["Artist"],
            credit: collections["Creator"],
            music: collections["AudioFile"],
            sampleStart: parseFloat(collections["SongPreviewTime"] || 0),
            sampleLength: 30000,
        };
        if (collections["BackgroundFile"] != null) {
            this.info.banner = collections["BackgroundFile"];
            this.info.background = collections["BackgroundFile"];
        }
        // Build Timeline
        let timeline = [];
        let bpmCollection = collections["TimingPoints"] || [];
        bpmCollection.forEach((entry, index) => {
            let time = parseFloat(entry["StartTime"] || 0);
            let bpm = parseFloat(entry["Bpm"] || 60);
            let bpmEvent = new BPMEvent(-1, bpm, index);
            bpmEvent.TIME = time;
            timeline.push(bpmEvent);
        });
        let svCollection = collections["SliderVelocities"] || [];
        svCollection.forEach((entry, index) => {
            let time = parseFloat(entry["StartTime"] || 0);
            let multiplier = parseFloat(entry["Multiplier"] || 0);
            let svEvent = new SVEvent(index);
            svEvent.TIME = time;
            svEvent.MULTIPLIER = multiplier;
            timeline.push(svEvent);
        });
        let noteCollection = collections["HitObjects"] || [];
        noteCollection.forEach((entry, index) => {
            let time = parseFloat(entry["StartTime"] || 0);
            let column = parseInt(entry["Lane"] || 1) - 1;
            // Held Note
            if (entry["EndTime"] != null) {
                let noteHeldTime = (parseFloat(entry["EndTime"]));
                let holdStart = new HoldEvent(index);
                holdStart.TIME = time;
                holdStart.TIME_END = noteHeldTime;
                holdStart.COLUMN = column;
                timeline.push(holdStart);
                let holdEnd = new HoldEndEvent(index);
                holdEnd.TIME = time;
                holdEnd.HEAD = holdStart;
                timeline.push(holdEnd);
            }
            // Note
            else {
                let noteStart = new NoteEvent(index);
                noteStart.TIME = time;
                noteStart.COLUMN = column;
                timeline.push(noteStart);
            }
        });
        timeline.sort(this.sortTimelineCompareTime);
        //  Get offset from First BPM
        if (timeline[0] instanceof BPMEvent) {
            this.info.offset = timeline[0].TIME;
        }
        this.charts.push({
            columns: this.standardType(collections["Mode"]),
            name: collections["DifficultyName"],
            difficulty: 0,
            timeline: timeline
        });
        // Set Types
        this._validTypes = ChartType.CMOD;
        return true;
    }
    standardType(type) {
        switch (type) {
            case 'Keys4':
                return 4;
            case 'Keys7':
                return 7;
        }
        return 0;
    }
    /**
     * Sort Timeline by Timestamp instead of Beat.
     */
    sortTimelineCompareTime(a, b) {
        if (a.TIME != b.TIME)
            return a.TIME - b.TIME;
        if (a.PRIORITY != b.PRIORITY)
            return a.PRIORITY - b.PRIORITY;
        if (a.INDEX != b.INDEX)
            return a.INDEX - b.INDEX;
        return 0;
    }
}
